import { c as _c } from "react/compiler-runtime";
import { Heading, Separator, Text, VStack } from '@chakra-ui/react';
import { PublishRequestForm } from '@src/components/sco/Requests/PublishRequestForm';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import { RequestDeleteForm } from '@src/components/sco/Requests/RequestDeleteForm';
import React from 'react';

/**
 * Final RequestBuilder accordion section: publish workflow + delete.
 * Reuses the standalone PublishRequestForm and RequestDeleteForm used elsewhere
 * (settings page, task publisher, dashboard publish CTA).
 */
export const SettingsPublishSection: React.FC<RequestBuilderFormProps> = props => {
  const $ = _c(13);
  const groupRequestId = props.groupRequest?.groupRequestId;
  if (!groupRequestId) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <VStack align="stretch" padding={4}><Text color="fg.muted">Request not loaded yet.</Text></VStack>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Heading fontWeight="semibold" size="sm">Publishing</Heading>;
    t1 = <Text color="fg.muted" textStyle="sm">Control whether this goal is public. Submitted goals are reviewed before they appear in search and on profiles.</Text>;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== groupRequestId) {
    t2 = <VStack align="stretch" gap={3}>{t0}{t1}<PublishRequestForm groupRequestId={groupRequestId} /></VStack>;
    $[3] = groupRequestId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Separator />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Heading fontWeight="semibold" size="sm">Danger zone</Heading>;
    t5 = <Text color="fg.muted" textStyle="sm">Permanently remove this request and related workspace data (game plan, matches, activity).</Text>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== groupRequestId) {
    t6 = <VStack align="stretch" gap={3}>{t4}{t5}<RequestDeleteForm groupRequestId={groupRequestId} /></VStack>;
    $[8] = groupRequestId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <VStack align="stretch" gap={6} padding={4}>{t2}{t3}{t6}</VStack>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};